/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Jinhyoung Jang (jangjh@rsupport.com)
 *
 * @description
 *
 * @created at 2024-08-03 11:50:30
 **/

import { isEmpty } from "lodash-es";
import { useCallback, useEffect, useMemo, useState } from "react";

import { usePhoneCall } from "@/frameworks/core/hooks";

const LOGTAG = "#useCallManager#";

export default function useCallManager(props: PushServices.Call.PhoneDetailProps) {
	const { callerID, tabID, callID: historyCallID } = props;
	const phoneCall = usePhoneCall();
	const [callID, setCallID] = phoneCall.state.id;
	const callStatus = phoneCall.state.status(callID)[0];
	const [callees, setCallees] = phoneCall.state.callees;
	const { myCallJoinState } = phoneCall.state.active;

	useEffect(() => {
		setCallees(props.callees);
	}, [props.callees]);

	useEffect(() => {
		if (callStatus === "END" || myCallJoinState?.status === "ENDED") {
			setTimeout(() => {
				setCallID("");
			}, 2000);
		}
		return () => {
			if (
				callStatus === "END" &&
				phoneCall.popup.info(callID) &&
				phoneCall.popup.info(callID)?.uiType !== "none"
			) {
				setCallees([]);
			}
		};
	}, [callStatus]);

	useEffect(() => {
		return () => {
			if (callStatus !== "END" || (myCallJoinState?.status && myCallJoinState?.status !== "ENDED")) {
				check_for_floating();
			}
		};
	}, [callID, props.callees]);

	const check_for_floating = useCallback(() => {
		try {
			if (callID?.length > 0) {
				const status = phoneCall.status(callID);
				if (status === "ONGOING" || status === "READY") {
					if (phoneCall.popup.info(callID)?.uiType === "fullSizeShare") {
						phoneCall.popup.show({
							...phoneCall.popup.info(callID)
						});
					} else {
						phoneCall.popup.show({
							callID,
							callerID,
							uiType: "floating"
						});
						setCallID("");
					}
				}
			}
		} catch (error) {
			console.warn(LOGTAG, "check_for_floating error", error);
		}
	}, [callID]);

	const new_props = useMemo(
		() => ({
			...props,
			callID: isEmpty(callID) ? historyCallID : callID,
			check_for_floating
		}),
		[callID, props]
	);

	return {
		check_for_floating,
		new_props
	};
}
